var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('img',{staticClass:"bannerImg",attrs:{"src":_vm.bannerImg,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }